module.exports = __webpack_public_path__ + "static/img/icon-phone.8d0f0268.png";